module.exports = __webpack_public_path__ + "b8be1669f7767ebeef2769c8b8c9f33c.pdf";